type TooltipFit = { key: string; width: number };
const fittedWidths = new WeakMap<HTMLElement, TooltipFit>();

// Balanced wrapping leaves unused space in the line box. Find the narrowest
// bubble that preserves the original line count, rather than padding that space.
export const fitTooltipText = (element: HTMLElement): void => {
    const style = window.getComputedStyle(element);
    const key = [
        element.textContent,
        style.maxWidth,
        style.maxHeight,
        style.font,
        style.lineHeight,
        style.padding,
    ].join('|');
    const cached = fittedWidths.get(element);
    if (cached?.key === key) {
        element.style.setProperty('width', `${cached.width}px`);
        return;
    }

    element.style.setProperty('width', 'max-content');
    const naturalWidth = Number.parseFloat(window.getComputedStyle(element).width);
    if (!Number.isFinite(naturalWidth) || naturalWidth <= 0) return;
    const originalHeight = element.scrollHeight;
    let low = Number.parseFloat(style.paddingLeft) + Number.parseFloat(style.paddingRight);
    let high = naturalWidth;

    for (let pass = 0; pass < 10 && high - low > 0.25; pass += 1) {
        const candidate = (low + high) / 2;
        element.style.setProperty('width', `${candidate}px`);
        if (element.scrollHeight <= originalHeight && element.scrollWidth <= element.clientWidth) {
            high = candidate;
        } else {
            low = candidate;
        }
    }

    const width = Math.min(naturalWidth, Math.ceil(high) + 1);
    element.style.setProperty('width', `${width}px`);
    fittedWidths.set(element, { key, width });
};
